export default __webpack_public_path__ + "static/media/womens-shoes.0cead3a8.png";